import apiClient from './apiClient';
import { useUserStore } from '../../store/UserStore';
import { UserData, UserAccountInfo } from '../../types/userData';

export const getUser = async (userId: string): Promise<UserData | null> => {
    try {
        const userResponse = await apiClient.get('/users', { params: { id: userId } });
        const userData = userResponse.data.data[0];

        const societyResponse = await apiClient.get('/societies', { params: { id: userData.societyId } });
        const societyData = societyResponse.data.data[0];

        const user: UserData = {
            id: userData.id,
            civility: userData.civility,
            firstname: userData.firstname,
            lastname: userData.lastname,
            email: userData.email,
            phoneNumber: userData.phoneNumber,
            profile: userData.profile,
            trainingCenter: societyData.name,
            societyId: userData.societyId
        };

        return user;
    } catch (error) {
        console.error('Error getting user:', error);
        return null;
    }
};

export const getUserInfo = async (): Promise<Array<UserAccountInfo> | null> => {
    try {
        const response = await fetch((process.env.REACT_APP_QW_API_URL as string) + '/users/accounts-info', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${useUserStore.getState().user.access_token}`
            }
        });

        const json = await response.json();
        const users = json.data;

        return users.map((user: UserAccountInfo) => ({
            id: user.id,
            group: user.group,
            organization: user.organization,
            profile: user.profile
        }));
    } catch (error) {
        console.error('Error getting user info:', error);
        return null;
    }
};
